import {Component, Input, ViewChild} from "@angular/core";
import {Map, MouseEvent, Marker} from "leaflet";
import {MdDialogRef, MaterialModule, MdSidenav} from "@angular/material";
import {List} from "immutable";
import { Router, ActivatedRoute, Params } from "@angular/router";

import {GuideService} from "../../services/guide.service";
import {SidenavService} from "../../services/sidenav.service";
import {MapService} from "../../services/map.service";
import {Spot, Guide, Category} from "../../core/model";

@Component({
  selector: "spot-list",
  template: require<any>("./spot-list.component.html"),
  styles: [
    require<any>("./spot-list.component.less"),
    require<any>("../../styles/main.less"),
    require<any>("../../styles/material.theme.scss")
  ]
})
export class SpotListComponent {

  private showSpot: string = "all";
  private guide: Guide = {} as Guide;
  private spots: Spot[] = [];
  private categories: Array<Category> = new Array<Category>();
  private searchText: string = "";

  constructor(private sidenavService: SidenavService, private guideService: GuideService, private router: Router, private mapService: MapService) {
    this.guideService.getActiveGuide().then(guide => {
      this.guide = guide;
      this.spots = guide.spots;
    });
    this.guideService.getCategories().then(categories => {
      this.categories = categories;
    });
  }

  ngOnInit() {

  }

  showAllMarker() {
    this.showSpot = "all";
    this.router.navigate(["/"]);
  }

  showMarker(spot: Spot) {
    this.showSpot = spot.name;
    this.router.navigate(["/map", spot._id]);
  }

  showDetails(spot: Spot) {
    this.showSpot = spot.name;
    this.router.navigate(["/spot", spot._id]);
    this.sidenavService.toggle();
  }

  public getSpots(category: Category) {
    let spotsForCategory: Array<Spot> = new Array<Spot>();
    this.spots.forEach(spot => {
      if (category.name === spot.category.name) {
        if (this.spotPassesSearchText(spot)) {
          spotsForCategory.push(spot);
        }
      }
    });
    return spotsForCategory;

  }

  spotPassesSearchText(spot: Spot): boolean {

    if (this.searchText === "") {
      return true;
    } else {
      let spotString: string = spot.name.toLowerCase();
      if (spot.description != undefined) {
        spotString += " " + spot.description.toLowerCase();
      }
      if (spotString.includes(this.searchText.toLowerCase())) {
        return true;
      }
    }
    return false;

  }

}



// WEBPACK FOOTER //
// ./src/app/components/spot-list/spot-list.component.ts